import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { WHATSAPP_URL, WhatsAppIcon } from "@/components/landing/WhatsApp";
import { PropietariosButton } from "@/components/landing/PropietariosModal";
import { IncidenciaButton } from "@/components/landing/IncidenciaButton";

const links = [
  { label: "Inicio", href: "#inicio" },
  { label: "El Sello", href: "#el-sello" },
  { label: "Servicios", href: "#servicios" },
  { label: "Contacto", href: "#contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-white/90 backdrop-blur-md border-b border-slate-100" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-24 flex items-center justify-between">
        <a href="#inicio" data-testid="nav-brand-logo" className="flex items-center">
          <img src="/logo.png" alt="AFGestiones — Gestión y Administración de Fincas" className="h-16 sm:h-[5.5rem] w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-8 xl:gap-10" data-testid="nav-links">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm font-medium text-slate-500 hover:text-slate-900 transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-btn"
            aria-label="Canal de mensajería y atención de AFGestiones"
            title="Canal de mensajería y atención de AFGestiones"
            className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-slate-300 text-slate-700 hover:border-[#25D366] hover:text-[#25D366] transition-colors duration-300"
          >
            <WhatsAppIcon className="w-[18px] h-[18px]" />
          </a>
          <IncidenciaButton testId="nav-incidencia-btn" label="Notificar Incidencia" />
          <PropietariosButton testId="nav-propietarios-btn" label="Portal del Propietario" />
          <a
            href="#contacto"
            data-testid="nav-presupuesto-btn"
            className="text-sm font-semibold text-white bg-slate-900 hover:bg-slate-800 rounded-full px-5 py-2.5 transition-colors duration-300"
          >
            Solicitar Presupuesto
          </a>
        </div>

        <div className="lg:hidden flex items-center gap-2">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-mobile-whatsapp-icon"
            aria-label="Canal de mensajería y atención de AFGestiones"
            title="Canal de mensajería y atención de AFGestiones"
            className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-slate-300 text-slate-700"
          >
            <WhatsAppIcon className="w-[18px] h-[18px]" />
          </a>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="p-2 text-slate-900"
            aria-label="Abrir menú"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden bg-white border-b border-slate-100 px-4 pb-6 pt-2 space-y-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.href.slice(1)}`}
              onClick={() => setOpen(false)}
              className="block text-base font-medium text-slate-700"
            >
              {l.label}
            </a>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-mobile-whatsapp-btn"
            className="inline-flex items-center gap-2 text-sm font-semibold text-slate-900 border border-slate-300 rounded-full px-5 py-2.5"
          >
            <WhatsAppIcon className="w-4 h-4 text-[#25D366]" /> Contactar por WhatsApp
          </a>
          <IncidenciaButton testId="nav-mobile-incidencia-btn" label="Notificar Incidencia" />
          <PropietariosButton testId="nav-mobile-propietarios-btn" label="Portal del Propietario" />
        </div>
      )}
    </header>
  );
}
